import TextAnswer from '@/components/shared/answer-types/text/text.vue';
import SelectListAnswer from '@/components/shared/answer-types/select-list/select-list.vue';
import NumberAnswer from '@/components/shared/answer-types/number/number.vue';
import { Select, Option } from 'element-ui';
import {
    MIN_CLUB_FOUNDATION_YEAR,
    MAX_CLUB_MEMBERS,
    MIN_CLUB_MEMBERS,
    MIN_CLUB_NAME_LENGTH,
    DEFAULTS,
    YES_NO_SELECT_OPTIONS
} from '../../constants/club-registration-constants.js';

export default {
    name: 'ClubDetailsSection',

    components: {
        'text-answer': TextAnswer,
        'select-list-answer': SelectListAnswer,
        'number-answer': NumberAnswer,
        [Select.name]: Select,
        [Option.name]: Option
    },

    props: {
        club: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        copyOptions: {
            type: Array,
            default: () => []
        },
        selectedCopyId: {
            type: [Number, String],
            default: null
        },
        countyOptions: {
            type: Array,
            default: () => []
        },
        isRenewalOptInLocked: {
            type: Boolean,
            default: false
        },
        clubStatus: {
            type: [Number, String],
            default: null
        },
        statuses: {
            type: Array,
            default: () => []
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        isReaffiliationMode: {
            type: Boolean,
            default: false
        },
        isRenewalOptInVisible: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            defaults: DEFAULTS,
            minClubYear: MIN_CLUB_FOUNDATION_YEAR,
            maxMembers: MAX_CLUB_MEMBERS,
            minMembers: MIN_CLUB_MEMBERS,
            minClubNameLength: MIN_CLUB_NAME_LENGTH,
            yesNoOptions: YES_NO_SELECT_OPTIONS
        };
    },

    computed: {
        currentYear() {
            return new Date().getFullYear();
        },
        localClub: {
            get() { return this.club; },
            set(value) { this.$emit('update:club', value); }
        },
        localValidation: {
            get() { return this.validation; },
            set(value) { this.$emit('update:validation', value); }
        },
        localSelectedCopyId: {
            get() { return this.selectedCopyId; },
            set(value) { this.$emit('update:selectedCopyId', value); }
        },
        localClubStatus: {
            get() { return this.clubStatus; },
            set(value) { this.$emit('update:clubStatus', value); }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/register-club/sections/club-details-section/club-details-section.js